import { jsx as m, jsxs as o } from "react/jsx-runtime";
import * as l from "react";
import { c as i } from "../clsx-OuTLNxxd.js";
import '../Stats.css';const I = "_stats_1f0qp_32", f = "_statsItem_1f0qp_41", n = "_statsItemTitle_1f0qp_60", p = "_statsItemValue_1f0qp_73", s = {
  stats: I,
  statsItem: f,
  statsItemTitle: n,
  statsItemValue: p
}, _ = l.forwardRef(({ className: t, ...a }, e) => /* @__PURE__ */ m("div", { className: i(s.stats, t), "data-cxy-name": "stats", ref: e, ...a })), u = l.forwardRef(({ "aria-label": t, className: a, title: e, value: c, ...r }, d) => /* @__PURE__ */ o(
  "div",
  {
    className: i(s.statsItem, a),
    ref: d,
    ...r,
    "aria-label": t,
    "data-testid": "stats-item",
    children: [
      /* @__PURE__ */ m("p", { "aria-hidden": !!t, className: s.statsItemValue, children: c }),
      /* @__PURE__ */ m("p", { "aria-hidden": !!t, className: s.statsItemTitle, children: e })
    ]
  }
));
_.displayName = "Stats";
u.displayName = "StatsItem";
export {
  _ as Stats,
  u as StatsItem
};
